import React, { useState } from 'react';
import HangarIconStyle from './style';
import {css} from 'emotion';
import {Icon} from '@maxmilhas/hangar-components-atomic/public';

const HangarIcon = ({tooltip, icon}) => {
    return (
        <div className={css`${HangarIconStyle}`}>
            <Icon name={icon} size="small" />
            {tooltip && <span className="hangar-icon-tooltip">{tooltip}</span> }
        </div>
    )
}

export default HangarIcon;